// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const smokehouse = defineModel({
  id: "smokehouse",
  batchId: "future",
  name: "Smokehouse",
  tags: ["building","smokehouse","low-poly","age-of-mcp","future"],
  summary: "Smokes meat and fish into preserved, nourishing food.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.78, 0.14, 0.78), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.78, 0.14, 0.78), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.58, 0.42, 0.1), color: "#6e4f30", position: [0, 0.35, -0.26] },
      { geometry: new THREE.BoxGeometry(0.1, 0.42, 0.52), color: "#5a4026", position: [-0.26, 0.35, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.42, 0.52), color: "#5a4026", position: [0.26, 0.35, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.8, 4), color: "#6b4a26", position: [-0.33, 0.4, -0.33] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.8, 4), color: "#6b4a26", position: [0.33, 0.4, -0.33] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.8, 4), color: "#6b4a26", position: [-0.33, 0.4, 0.33] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.8, 4), color: "#6b4a26", position: [0.33, 0.4, 0.33] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.78, 0.14, 0.78), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.58, 0.84, 0.1), color: "#6e4f30", position: [0, 0.56, -0.26] },
      { geometry: new THREE.BoxGeometry(0.1, 0.84, 0.52), color: "#5a4026", position: [-0.26, 0.56, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.84, 0.52), color: "#5a4026", position: [0.26, 0.56, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [-0.33, 0.7, -0.33] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [0.33, 0.7, -0.33] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [-0.33, 0.7, 0.33] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [0.33, 0.7, 0.33] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.78, 0.14, 0.78), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.58, 0.96, 0.1), color: "#6e4f30", position: [0, 0.62, -0.26] },
      { geometry: new THREE.BoxGeometry(0.1, 0.96, 0.52), color: "#5a4026", position: [-0.26, 0.62, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.96, 0.52), color: "#5a4026", position: [0.26, 0.62, 0] },
      { geometry: new THREE.BoxGeometry(0.7, 0.06, 0.425206), color: "#4a3020", position: [0, 1.24, 0.16], rotation: [0.71883, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.7, 0.06, 0.425206), color: "#4a3020", position: [0, 1.24, -0.16], rotation: [-0.71883, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.74, 0.07, 0.07), color: "#33210f", position: [0, 1.38, 0] },
      { geometry: new THREE.BoxGeometry(0.16, 0.1, 0.14), color: "#5a4026", position: [0, 1.43, 0] },
      { geometry: new THREE.SphereGeometry(0.06, 7, 5), color: "#8a857e", position: [0, 1.58, 0], scale: [1, 0.9, 1] },
      { geometry: new THREE.SphereGeometry(0.045, 6, 4), color: "#8a857e", position: [0.04, 1.7, -0.02], scale: [1, 0.8, 1] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.5, 5), color: "#3a2c1a", position: [0, 0.86, 0.18], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.5, 5), color: "#3a2c1a", position: [0, 0.66, 0.18], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.BoxGeometry(0.05, 0.18, 0.03), color: "#b0916a", position: [-0.16, 0.76, 0.18] },
      { geometry: new THREE.BoxGeometry(0.05, 0.18, 0.03), color: "#b0916a", position: [0, 0.76, 0.18] },
      { geometry: new THREE.BoxGeometry(0.05, 0.18, 0.03), color: "#b0916a", position: [0.16, 0.76, 0.18] },
      { geometry: new THREE.BoxGeometry(0.07, 0.16, 0.04), color: "#8a4a44", position: [-0.16, 0.56, 0.18] },
      { geometry: new THREE.BoxGeometry(0.07, 0.16, 0.04), color: "#8a4a44", position: [0, 0.56, 0.18] },
      { geometry: new THREE.BoxGeometry(0.07, 0.16, 0.04), color: "#8a4a44", position: [0.16, 0.56, 0.18] },
      { geometry: new THREE.BoxGeometry(0.3, 0.14, 0.16), color: "#5a4026", position: [0, 0.21, 0.14] },
      { geometry: new THREE.BoxGeometry(0.18, 0.07, 0.06), color: "#ff7a2e", position: [0, 0.2, 0.23] },
    ] },
  ],
  animations: [],
});
